import { mapInstitutionFields } from '@/adapters/institutions'
import { directusClient, fileFields, imageFields, readItems } from '@/shared/utils/directus'

export default async function getInstitutions({
  locale = 'ru-RU',
  countryId,
  is_partner,
  is_featured,
}: {
  locale?: string
  countryId?: string
  is_partner?: boolean
  is_featured?: boolean
} = {}) {
  const collectionName = 'institutions'

  const filter = {
    translations: { languages_code: { _eq: locale } },
    country: countryId,
    is_partner: typeof is_partner === 'boolean' ? is_partner : undefined,
    is_featured: typeof is_featured === 'boolean' ? is_featured : undefined,
  }

  try {
    const items = await directusClient.request<Directus.Institution[]>(
      readItems(collectionName, {
        filter,
        deep: {
          translations: { _filter: { languages_code: { _eq: locale } } },
        },
        fields: [
          'id',
          'url',
          {
            translations: ['name'],
            country: ['id', { translations: ['name'], image: imageFields }],
            logo: fileFields,
            logo_ru: fileFields,
            logo_black: fileFields,
            logo_black_ru: fileFields,
          },
        ],
      })
    )

    return items.map(item => {
      return mapInstitutionFields(item, locale)
    })
  } catch (error) {
    return []
  }
}
